import React, { Component } from "react";
import { Tooltip, Dropdown } from "antd";
import category from "../../../../images/skill-store/category.png";
import { getDraftSkillCount, changeActiveCategory } from "../../../../redux/actions/skill";
import { withRouter } from "react-router";
import { compose } from "redux";
import { connect } from "react-redux";


import { Blocks, ChevronDown, Database, DollarSign, GalleryVerticalEnd, Layers2, LayoutList, LibraryBig, Percent, Scale, Search } from "lucide-react";




export class SkillsHubSearch extends Component {
  constructor() {
    super();
    this.state = {
      searchItem: "",
      categories: [
        { id: 1, 
          name: "All", 
          icon: <GalleryVerticalEnd strokeWidth={1.5} size={20} /> 
        },
        
        {
          id: 2,
          name: "Finance and Accounting",
          icon: <DollarSign strokeWidth={1.5} size={20} />,
        },
        {
          id: 3,
          name: "Human Resources (HR)",
          icon: <LayoutList strokeWidth={1.5} size={20} />,
        },
        {
          id: 4,
          name: "Legal and Compliance",
          icon: <Scale strokeWidth={1.5} size={20} />,
        },
        {
          id: 5,
          name: "Information Technology (IT)",
          icon: <LibraryBig strokeWidth={1.5} size={20} />,
        },
        {
          id: 6,
          name: "Marketing",
          icon: <Layers2 strokeWidth={1.5} size={20} />,
        },
        {
          id: 7,
          name: "Sales",
          icon: <Percent strokeWidth={1.5} size={20} />,
        },
       
      ],
      items:[
        {
          key: 23,
          label: 'Data Analytics',
          onClick: () => {
            this.changeCategory("Data Analytics");
          }
          
        },
        {
          key: 9,
          label: 'Operations',
          onClick: () => {
            this.changeCategory("Operations");
          }
          
        },
        {
          key: 10,
          label: 'Product Management / R&D',
          onClick: () => {
            this.changeCategory("Product Management / R&D");
          }
        },
        {
          key: 11,
          label: 'Customer Success and Support',
          onClick: () => {
            this.changeCategory("Customer Success and Support");
          }
        },
        {
          key: 12,
          label: 'Banking',
          onClick: () => {
            this.changeCategory("Banking");
          }
        },
        {
          key: 13,
          label: 'Insurance',
          onClick: () => {
            this.changeCategory("Insurance");
          }
        },
        {
          key: 14,
          label: 'Healthcare (Providers and Hospitals)',
          onClick: () => {
            this.changeCategory("Healthcare (Providers and Hospitals)");
          }
        },
        {
          key: 15,
          label: 'Manufacturing',
          onClick: () => {
            this.changeCategory("Manufacturing");
          }
        },
        {
          key: 16,
          label: 'Pharmaceuticals',
          onClick: () => {
            this.changeCategory("Pharmaceuticals");
          }
        },
        {
          key: 17,
          label: 'Consumer Goods (FMCG)',
          onClick: () => {
            this.changeCategory("Consumer Goods (FMCG)");
          }
        },
        {
          key: 18,
          label: 'Retail',
          onClick: () => {
            this.changeCategory("Retail");
          }
        },
        {
          key: 19,
          label: 'Hospitality (Hotels, Travel)',
          onClick: () => {
            this.changeCategory("Hospitality (Hotels, Travel)");
          }
        },
        {
          key: 20,
          label: 'Higher Education',
          onClick: () => {
            this.changeCategory("Higher Education");
          }
        },
        {
          key: 21,
          label: 'Hi-Tech / Software and SaaS',
          onClick: () => {
            this.changeCategory("Hi-Tech / Software and SaaS");
          }
        },
        
      
      ]
    };
  }


  changeCategory = (cat) => {
    this.props.changeActiveCategory(cat);
    if(this.props.location.pathname !== "/dashboard/skill-store/agent-hub") {
      this.props.history.push(`/dashboard/skill-store/agent-hub`);
      this.props.changeActiveCategory(cat);
    }
    this.props.history.push(`/dashboard/skill-store/agent-hub`);
  };


  onChange = (e) => {
    this.setState({
      searchItem: e.target.value,
    });
  };

  onKeyPress = (e) => {
    if (e.key === "Enter") {
      this.props.history.push({
        pathname: `/dashboard/skill-store/search/${this.state.searchItem}`,
      });
    }
  };

  render() {
    return (
     
      <div className="ai-task">
        <h2>Welcome to world's first AI Agents Hub</h2>
        <div class="search-g-input">
          <div class="input-gs">
            <Search />
            <input
              className="super-search"
              value={this.state.searchItem}
              onKeyDown={(e) => this.onKeyPress(e)}
              onChange={(e) => this.onChange(e)}
              type="text"
              placeholder="Search"
            />
          </div>
        </div>
       

        <div className="cat-list">
          {this.state.categories.map((category) => (
            <Tooltip title={category.name} placement="bottom">
              <div key={category.id} className={`cat-item ${this.props.skills.activeCategory === category.name ? 'active' : ''}`}>
                <div className="cat-ico" onClick={() => this.changeCategory(category.name)}>{category.icon ? category.icon : <Blocks size={20} strokeWidth={1.5} />}</div>
                <span>
                  {category.name.length > 22
                    ? category.name.slice(0, 22) + "..."
                    : category.name}
                    {/* {category.name} */}
                </span>
              </div>
            </Tooltip>
          ))}

          <Dropdown menu={{ items: this.state.items }} trigger={['click']} placement="bottomRight" o>
              <div onClick={e => e.preventDefault()}>
                  <div className={`cat-item ${this.props.skills.activeCategory === category.name ? 'active' : ''}`}>
                    <div className="cat-ico"><ChevronDown size={20} strokeWidth={1.5} /></div>
                    <span>More</span>
                  </div>
              </div>
            </Dropdown>          
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  skills: state.skillReducer,
  userReducer: state.userReducer,
  searchTerm: state.searchTerm,
});

export default compose(
  withRouter,
  connect(mapStateToProps, {
    getDraftSkillCount,
    changeActiveCategory,
  })
)(SkillsHubSearch);
